import React from "react";
import { useTranslation } from "react-i18next";
import { PlanId } from "@services/jointBillServiceProviderBillPlans/types";
import { BillInsuranceRulesContent } from "./components/BillInsuranceRulesContent";
import { HouseInsuranceRulesContent } from "./components/HouseInsuranceRulesContent";

interface IMaxPlanRulesContentProps {
  jointBillServicePlanId: PlanId;
}

export const MaxPlanRulesContent: React.FC<IMaxPlanRulesContentProps> = (
  props,
) => {
  const { jointBillServicePlanId } = props;

  const { t } = useTranslation();

  return (
    <div className="lg:h-[60vh] overflow-y-auto">
      {(jointBillServicePlanId == PlanId.MAX ||
        jointBillServicePlanId === PlanId.MCI) && (
        <HouseInsuranceRulesContent
          title={t(`planMaxDocumentation.${PlanId.MCI}.title`)}
          hideTitle={jointBillServicePlanId == PlanId.MCI}
        />
      )}
      {(jointBillServicePlanId == PlanId.MAX ||
        jointBillServicePlanId === PlanId.MBI) && (
        <BillInsuranceRulesContent
          title={t(`planMaxDocumentation.${PlanId.MBI}.title`)}
          hideTitle={jointBillServicePlanId == PlanId.MBI}
        />
      )}
    </div>
  );
};
